import { render, staticRenderFns } from "./TagsPosts.vue?vue&type=template&id=3fefcc54&"
import script from "./TagsPosts.vue?vue&type=script&lang=js&"
export * from "./TagsPosts.vue?vue&type=script&lang=js&"
import style0 from "./TagsPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports